import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const appRoutes: Routes = [
	{ path: '', redirectTo: 'booking/students', pathMatch: 'full' }
];

export const routing: ModuleWithProviders = RouterModule.forRoot(appRoutes);


// WEBPACK FOOTER //
// ./src/bus/parent/AppRouting.ts